import _ from 'lodash';
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import ItemTypes from '../ItemTypes/ItemTypes';
import SlideItem from '../SlideItem/SlideItem';

import reducerStore from '../../reducers/reducerStore';

class SlideList extends Component {

    constructor(props) {
        super(props);

        this.getSlides = this.getSlides.bind(this);
        this.reorder = this.reorder.bind(this);
        this.reorderDone = this.reorderDone.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.slides.length !== this.props.slides.length) {
            reducerStore.dispatch({ type: 'UPDATE SLIDES2', data: props.slides });
        }
    }

    getSlides() {
        const { currentSlideId, currency, slides, slidesData, companyProfile, tvIndex, goToSlide } = this.props;
        const channelSlides = _.filter(slides, (s) => s.tvIndex === tvIndex);

        return channelSlides.map((slide, index) => {
            let slideContainerClasses = ['slide-container'];
            if (currentSlideId === slide.id) {
                slideContainerClasses.push('active');
            }
            return (
                <div className={slideContainerClasses.join(' ')} key={slide.id} onClick={() => goToSlide(slide.id)}>
                    <p className='slide-number'>{index+1}</p>
                    <SlideItem
                        currentSlideId={currentSlideId}
                        item={slide}
                        index={index}
                        slidesData={slidesData}
                        companyProfile={companyProfile}
                        currency={currency}
                        reorderDone={this.reorderDone}
                        reorder={this.reorder}
                        tvIndex={this.props.tvIndex}
                        moveToTv={this.props.moveToTv}
                        editSlide={this.props.editSlide}
                        removeSlide={this.props.removeSlide}
                    />
                </div>
            );
        }); 
    }


    reorder(oldIndex, newIndex, slide) {
        const slides = this.props.slides;
        const currentSlides = _.filter(slides, { tvIndex: slide.tvIndex });

        let newSlides = _.concat(currentSlides, _.differenceBy(slides, currentSlides, 'tvIndex'));

        if (newIndex !== null) {
            newSlides.splice(newIndex, 0, newSlides.splice(oldIndex, 1)[0]);
        } else {
            newSlides.splice(oldIndex, 1);
        }

        newSlides = _.filter(newSlides, (slide) => {
            if (slide) return true;
            return false;
        });

        reducerStore.dispatch({ type: 'UPDATE SLIDES2', data: newSlides });
    }

    reorderDone() {
        const theSlides = _.cloneDeep(this.props.slides);


        _.each(_.filter(theSlides, (s) => s.tvIndex === this.props.tvIndex), (slide, index) => {
            slide.position = index;
        });

        this.props.reorderDone(theSlides);
    }

    render() {
        const { connectDropTarget, createNewSlide } = this.props;

        const slides = this.getSlides();
        const isInactiveSlides = _.isNil(createNewSlide);

        const classes = ['slides-overview'];
        if (isInactiveSlides) classes.push('inactive-overview');
        return connectDropTarget(
            <div className={classes.join(' ')}>
                {slides}
                {createNewSlide &&
                    <div className="slide-container">
                        <div
                            className="slide add-slide"
                            onClick={() => { this.props.createNewSlide(); }}
                        >
                            <div className="inner-add-slide">
                                <i className="fa fa-plus fa-2x" />
                            </div>
                        </div>
                    </div>
                }
            </div>,
        );
    }
}

const SlideTarget = {
    canDrop: () => true,
    drop: () => ({ moved: true }),
    hover(props, monitor, component) {
        const dragTvId = monitor.getItem().tvIndex;
        const slideId = monitor.getItem().id;
        const hoverTvId = props.tvIndex;

        if (dragTvId === hoverTvId) {
            return;
        }

        // Time to actually perform the action
        props.moveToTv(monitor.getItem().id, hoverTvId, 0);

        monitor.getItem().tvIndex = hoverTvId;
        monitor.getItem().index = 0;
    },
};

/**
 * Specifies which props to inject into your component.
 */
const collect = (connect, monitor) => ({
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDropTarget: connect.dropTarget(),
    // You can ask the monitor about the current drag state:
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
});

SlideList.propTypes = {
    companyProfile: React.PropTypes.object,
    connectDropTarget: React.PropTypes.func,
    createNewSlide: React.PropTypes.func,
    currency: React.PropTypes.string,
    currentSlideId: React.PropTypes.string,
    editSlide: React.PropTypes.func,
    goToSlide: React.PropTypes.func,
    moveToTv: React.PropTypes.func,
    removeSlide: React.PropTypes.func,
    reorderDone: React.PropTypes.func,
    slides: React.PropTypes.array,
    slidesData: React.PropTypes.object,
    tvIndex: React.PropTypes.number,
};

export default DropTarget(ItemTypes.SLIDE, SlideTarget, collect)(SlideList);



/** WEBPACK FOOTER **
 ** ./client/components/SlideList/SlideList.jsx
 **/